import { Injectable } from '@angular/core';
import { DVCVariableSet, initialize } from '@devcycle/js-client-sdk';
import { environment } from '@environments/environment';
import { PermissionsService } from '@app/modules/auth';
import { of, ReplaySubject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { isBoolean } from '@app/modules/shared/utilities/utilities';

const mockDevCycleVariables: DVCVariableSet = {
  'voltron-live-enabled': {
    _id: '637d188488fc66b8982c4b98',
    key: 'voltron-live-enabled',
    type: 'Boolean',
    value: false
  },
  'maps-incident-button-enabled': {
    _id: '63da1f0eb3cba31c316111f6',
    key: 'maps-incident-button-enabled',
    type: 'Boolean',
    value: false
  },
  'vdo-driver-availability-enabled': {
    _id: '642352e43b01905b82cb4c49',
    key: 'vdo-driver-availability-enabled',
    type: 'Boolean',
    value: true
  },
  'zones-enabled': {
    _id: '6508d6a863e232202d283052',
    key: 'zones-enabled',
    type: 'Boolean',
    value: true
  }
};

@Injectable({
  providedIn: 'root'
})
export class FeatureToggleService {
  // private devCycleClient;
  private variables: DVCVariableSet;
  // private variablesInitialized = false;
  public variableSubject: ReplaySubject<DVCVariableSet> = new ReplaySubject();
  constructor(private permissions: PermissionsService) {}

  initializeDevCycle(companyId) {
    this.permissions.getUser().subscribe(user => {
      // const dvcUser = {
      //   isAnonymous: false,
      //   user_id: user.id,
      //   email: user.email,
      //   name: `${user.firstName} ${user.lastName}`,
      //   privateCustomData: {
      //     userId: user.id,
      //     emailAddress: user.email,
      //     companyId
      //   }
      // };

      this.variables = mockDevCycleVariables;
      // this.variablesInitialized = true;
      this.variableSubject.next(this.variables);

      // this.devCycleClient = initialize(environment.devCycle.clientId, dvcUser);
      // this.devCycleClient.onClientInitialized().then(client => {
      //   this.variables = client.allVariables();
      //   this.variablesInitialized = true;
      //   this.variableSubject.next(client.allVariables());
      // });
      // // https://docs.devcycle.com/docs/sdk/client-side-sdks/javascript#subscribing-to-sdk-events
      // this.devCycleClient.subscribe('variableUpdated:*', (key, val) => {
      //   if (this.variablesInitialized) {
      //     this.variables[key] = val;
      //     this.variableSubject.next(this.variables);
      //   }
      // });
    });
  }

  // this returns the value of the DevCycle variable
  // which could be type: Boolean, String, Number, JSON
  // see https://docs.devcycle.com/docs/home/feature-management/features-and-variables/creating-variables-and-variations
  valueForKey(key: string) {
    return this.variableSubject.pipe(map(variables => variables[key]?.value));
  }

  // this returns a boolean Observable & should be used in templates to determine if the feature is enabled
  isFeatureEnabled(key: string) {
    return this.variableSubject.pipe(
      switchMap(variables => {
        const keyVal = variables[key]?.value;
        if (isBoolean(keyVal)) {
          return of(keyVal);
          // later on we could add other logic here, if value was a number or string or some object
          // but for now we only have booleans, so the no-op is to return false
        } else {
          return of(false);
        }
      })
    );
  }
}
